<template>
  <div class="timepicker-container">
    <div class="timepicker ms-dropdown">
      <div bold class="mr-12-px">{{ $t('i18nComponent.Date.Time') }}</div>
      <div class="change-hour">
        <ms-number
          v-model="hours"
          max="23"
          min="0"
          :spin="true"
          leading-zero="keep"
          :keepZero="true"
          class="input-time"
          @keydown="updateHour"
          @input="onInputHour"
        />
      </div>
      <div class="mr-6-px ml-6-px">:</div>
      <div class="change-minute">
        <ms-number
          ref="min"
          v-model="minutes"
          max="59"
          min="0"
          :spin="true"
          leading-zero="keep"
          :keepZero="true"
          class="input-time"
          @keydown="updateMin"
          @input="onInputMin"
        />
      </div>
      <div class="mr-6-px ml-6-px">:</div>
      <div class="change-second">
        <ms-number
          ref="second"
          v-model="seconds"
          max="59"
          min="0"
          :spin="true"
          leading-zero="keep"
          :keepZero="true"
          class="input-time"
          @keydown="updateSecond"
          @input="onInputSecond"
        />
      </div>
    </div>
    <div class="timepicker-footer flex-row">
      <button class="pick-today-button" @click.stop.prevent="onNow">Hiện tại</button>
      <button class="pick-today-button" @click.stop.prevent="onAccept">Đồng ý</button>
    </div>
  </div>
</template>

<script>
import {getCurrentInstance} from 'vue';
export default {
  name: 'Timepicker',
  props: {
    value: {
      type: Date,
      default: null,
    },
  },

  setup() {
    const {proxy} = getCurrentInstance();
  },
  data() {
    return {
      hours: this.value.getHours(),
      minutes: this.value.getMinutes(),
      seconds: this.value.getSeconds(),
      localValue: this.value,
    };
  },
  watch: {
    value(oldVal, newVal) {
      newVal = newVal || new Date();
      this.hours = newVal.getHours();
      this.minutes = newVal.getMinutes();
      this.seconds = newVal.getSeconds();
      return newVal;
    },
  },
  computed: {},
  methods: {
    /**
     * Kiểm tra giá trị nhập vào input giờ
     */
    onInputHour(e) {
      // hàm này kiểm tra focus sang input min
      const me = this;
      this.$nextTick(() => {
        const hour = me.hours;
        if ((hour.toString().length === 1 && hour >= 3) || hour.toString().length === 2) {
          me.updateTime(hour, null, null);
        }
      });
    },

    /**
     * Kiểm tra giá trị nhập vào input phút
     */
    onInputMin(e) {
      const me = this;
      this.$nextTick(() => {
        const min = me.minutes;
        if ((min.toString().length === 1 && min >= 6) || min.toString().length === 2) {
          me.updateTime(null, min, null);
        }
      });
    },

    /**
     * Kiểm tra giá trị nhập vào input giây
     */
    onInputSecond(e) {
      const me = this;
      this.$nextTick(() => {
        const second = me.seconds;
        if ((second.toString().length === 1 && second >= 6) || second.toString().length === 2) {
          // update ra ngoai
          me.updateTime(null, null, second);
        }
      });
    },

    /**
     * Cập nhật giờ
     */
    updateHour(e) {
      this.$nextTick(() => {
        this.checkKeyDown(e);
        this.updateTime(this.hours, null, null);
      });
    },

    /**
     * Cập nhật phút
     */
    updateMin(e) {
      this.$nextTick(() => {
        this.checkKeyDown(e);
        this.updateTime(null, this.minutes, null);
      });
    },

    /**
     * Cập nhật giây
     */
    updateSecond(e) {
      this.$nextTick(() => {
        this.checkKeyDown(e);
        this.updateTime(null, null, this.seconds);
      });
    },

    /**
     * Thực hiện cập nhật Giờ/Phút/Giây
     */
    updateTime(hour, min, second) {
      const me = this;

      const valueDateTime = me.value;
      if (valueDateTime && valueDateTime instanceof Date) {
        if (hour) {
          valueDateTime.setHours(hour);
        }
        if (min) {
          valueDateTime.setMinutes(min);
        }
        if (second) {
          valueDateTime.setSeconds(second);
        }

        this.$emit('input', valueDateTime);
        this.$emit('update:modelValue', valueDateTime);
      }
    },

    /**
     * Kiểm tra nếu keyDown có KeyCode là Enter thì ẩn form, submit giá trị
     */
    checkKeyDown(e) {
      if (e.keyCode === 13) {
        this.onAccept();
      }
    },

    /**
     * Lấy giá trị giờ hiện tại
     */
    onNow() {
      const now = new Date();
      this.hours = now.getHours();
      this.minutes = now.getMinutes();
      this.seconds = now.getSeconds();
      this.updateTime(this.hours, this.minutes, this.seconds);
      this.onHide();
    },

    /**
     * Đồng ý
     * ẩn form, submit giá trị
     */
    onAccept() {
      this.updateTime(this.hours || 0, this.minutes || 0, this.seconds || 0);
      this.onHide();
    },

    /**
     * Ẩn form
     */
    onHide() {
      this.$emit('hideForm');
    },

    /**
     * Ẩn form khi click ra ngoài
     */
    closeOut(e) {
      const me = this;
      if (
        !e.target.closest('.timepicker') &&
        (!e.target.closest('.ms-timepicker') || e.target.closest('.ms-timepicker') != me.$parent.$el)
      ) {
        this.onHide();
      }
    },
  },

  /**
   * Thêm sự kiện click ra ngoài để ẩn form
   */
  created() {
    document.addEventListener('click', this.closeOut);
  },
  /**
   * Xóa sự kiện click ra ngoài để ẩn form
   */
  beforeUnmount() {
    const me = this;
    document.removeEventListener('click', me.closeOut);
  },
  /**
   * Lấy chiều cao, chiều rộng của form
   */
  mounted() {
    this.height = this.$el.offsetHeight;
    this.width = this.$el.offsetWidth;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/TimePicker.scss';
</style>
